<template>
    <div>
        <div class="banner-area pd-bottom-120 banner-small-inner bg-light bg-relative bg-cover">
            <div class="container">
                <h4>Más acerca de nosotros.</h4>
                <h3>Ayudando a numerosas empresas a alcanzar el éxito en el mundo digital desde hace 10 años.</h3>
                <div class="row">
                    <div class="col-lg-6 mt-lg-4 pt-lg-2">
                        <p  style="text-align: justify;">En Smaco, creemos en la colaboración y la comunicación transparente con nuestros clientes. Trabajamos en estrecha colaboración contigo para entender tus necesidades y garantizar que nuestras soluciones aborden los desafíos específicos de tu negocio.
Valoramos la satisfacción del cliente y nos esforzamos por establecer relaciones a largo plazo basadas en la confianza y el éxito mutuo. </p>
                    </div>
                    <div class="col-lg-6 order-lg-first text-lg-center">
                        <div class="scroll-down top_image_bounce">
                            <a href="#about-area">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40" height="80" viewBox="0 0 40 80">
                                <image id="scroll" width="40" height="80" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAABQCAYAAABrjzfBAAADwElEQVRoge2bP1LbQBTGP5xQsCoiThD7BIgTxL5BOEGcE0CqlIaSytClg5wA0qUzOQHmBEY3EIW2JfM833oW2bIl78rSJPpmdjwGefent3/13tOeOjjAluoDiAB84mfIIkoAPLM8AXhgWVKq9drWywIKwCmAMwBTq/EpoRLrui5LnzcR8toLgs/lC1AqHwEYArgGcGs3UlACe07YBegmwE6BusViMwAvAHpspCwc+Bu5wQGAGMCE39dqkwXHAD4DOGE3+lSXkPep1t/y6s2zYMgfHwI4rgAOtKjU3Q2UegyUClddlAc4YTcMrYFfhZJU6xNOtruigGNrvOxEqdbSVhwoNc629z7zfcgxd7wrOEuydElXx6nWV+bP9iQxg3aw5SzdSvYyEygVkaGXaj0fWnYXyzr3c5dwWaVaT7nOjsy/jAVrsR5W7CSczTNjRWPBEVf32qxnxK695phcWHBWh/WQsxcHSkmPPqZaH3a4mSdNsJ5RqrWwTAOl+gbwTzPQ3kgW70gAj/LOajVLmOYW7Dapey3JknPUZECZF6HM4leZzXVRrDuwBkq9Fjmw1qoW0FUtoKv+O8CZ5/raLnZWC+iqFtBVLaCrWkBXtYCuagFd9c8BRg5tmeBOKZUFfAQgz9E3JRqL6CCfbXOgLQu4R//1Hhsbbbj+lDcVM9ZS2kGQdaIX0ZTOdok4TXj9xYrfmdBZz8W14jJJpNGBFRmwNbTCXk5+H9dZbCDHVigWtJ4Xj62PZeaZ0YEzfh/6jBb48m6FnKlmZhe23q68W3Yg+8mnv9HnTvKLgPce6/QKaPzcXkO3PgGfM59etM1CnaekCldye9xyVQvoqhbQVR0TcmoaGCPviQH80ACmrOYxxA63pjrSUDZJAOMOg9n9BgIK09RY8KgBQFnN0/g6PIXIo+HHppAxqSJMtX4wy4ykgXytmcuWSZNZpKUskmkqznZb0orEnkWSkWR/GAsmmQefOvVFrMfUlDfJZaGV4FNFQuNGC2ath8xWl9BDcFfHzsKdQ+AuDBxyclivuLPsZNIYCwZKiWEkd/DNMMtLsp3wGaNySAEMlBJvWZRqvbSj5Z1mTiy3WZXdHRKuy7G/pDzAhPtzTPdZacdjAUWs+yXVemAyLrN6t7+/v66q30zwvqElYw/rpNTzHcAPAJep1ufrLi5yYL2l+Xscm2W8q7a63CFmzM/ucUKuVdHnYpO23LUcl2JJ2Y7kNGTefLB9NFLstyWkyJZaardyfV1DipyEzJsP9usaUmTBlxuQz/KvawD4CybGJEiPys7UAAAAAElFTkSuQmCC"/>
                                </svg>
                            </a>
                        </div>  
                    </div>
                </div>
            </div>
        </div>
        <template>
    <div class="text-center">
        <img :src="require('@/assets/img/bg/smaco-9.jpg')" style="width: 50%;" alt="img" >
    </div>
</template>
    </div>
</template>

<script>
    import Swiper from 'swiper';
    import 'swiper/swiper-bundle.css';

    export default {
        name: "Banner",
        mounted(){
            new Swiper('.banner-slider-about', {
                slidesPerView: 1,
                slidesPerGroup: 1,
                loop: true,
                speed: 1000,
                autoplay: {
                    delay: 4000,
                },
            })
        },
        data() {
            return {
                showPopup: false,
            };
        },
    }
</script>

<style scoped>
    .slide-item {
        background-image: url('~@/assets/img/bg/2.png');
    }
    .banner-slider-about {
        overflow: hidden;
    }
    .banner-video-area-2 .banner-content-area {
        z-index: 2;
    }
    .video-popup {
        position: fixed;
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.9);
        z-index: 999999;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/about/Banner.vue